import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export const RequireAuth = ({ access, children }) => {
    const navigate = useNavigate();

    useEffect(() => {
        if (!localStorage.getItem("new_auth")) {
            navigate("/Portal/Login");
            console.log(localStorage.getItem("new_auth"))
        }
        else {
            filterPage(localStorage.getItem("new_auth"))
        }
    })

    const filterPage = (data) => {
        if (access.includes(data)) {
            return
        }
        navigate("/Portal/Unauthorized")
    };

    return children
}